export const TECH_WORKS_MODULE_NAME = "techWorksPage";
export const TECH_WORKS_TAG_TYPE = "TechWorks";
export const TECH_WORKS_LIST_TAG = {
  type: TECH_WORKS_TAG_TYPE,
  id: "LIST",
} as const;
